import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { Button } from './Button';
const checkoutUrl = 'https://ballet-teacher-ready.impultienda.ar/checkout';
function trackCheckout() {
  const fbq = (window as Window & {
    fbq?: (...args: unknown[]) => void;
  }).fbq;
  fbq?.('track', 'InitiateCheckout', {
    content_name: 'Ballet Teacher Ready Complete Teaching Library',
    value: 27,
    currency: 'USD'
  });
}
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-16 pt-14 sm:pb-24 sm:pt-20" data-id="element-154">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[620px] bg-ballet-blush/60" data-id="element-155" />
      <div className="relative mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55
      }} data-id="element-157">
          <p className="mb-5 inline-flex items-center rounded-full border border-ballet-gold/60 bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-[0.16em] text-ballet-rose" data-id="element-158">
            Ballet Teacher Ready™
          </p>
          <h1 className="mx-auto max-w-4xl font-display text-5xl font-semibold leading-[0.92] text-ballet-ink sm:text-6xl lg:text-7xl" data-id="element-159">
            Solve an entire year of ballet lessons{' '}
            <span className="text-ballet-rose" data-id="element-160">in just 5 minutes.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.65,
        delay: 0.08
      }} className="mt-8 w-full sm:mt-10" data-id="element-161">
          <img src="https://cdn.magicpatterns.com/uploads/wFFkPPNMfqb1P66BHgbfy3/seguridad_e_higiene_(4).png" alt="Ballet Teacher Ready complete teaching library with class finder and five bonus guides" className="mx-auto w-full max-w-2xl drop-shadow-[0_20px_30px_rgba(105,77,65,0.16)]" data-id="element-162" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.18
      }} className="mt-7" data-id="element-163">
          <p className="mx-auto max-w-2xl text-base leading-7 text-ballet-muted sm:text-lg" data-id="element-164">
            The complete professional teaching library—ready to open, teach, and
            inspire from today. Designed for ballet teachers guiding dancers
            ages 3–16.
          </p>
          <div className="mt-8" data-id="element-165">
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} data-id="element-166">
              GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>
          </div>
          <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-3 text-sm font-medium text-ballet-muted" data-id="element-167">
            {['Premium Teaching Library', '5 Strategic Bonuses', 'Immediate Access'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-168">
                <CheckCircle2Icon size={17} className="text-ballet-gold" aria-hidden="true" data-id="element-169" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}